export const FLAG_GETTING_DEPOSITS = 'FLAG_GETTING_DEPOSITS';
export const GET_DEPOSITS = 'GET_DEPOSITS';
export const CLEAR_DEPOSITS = 'CLEAR_DEPOSITS';
export const GET_DEPOSIT = 'GET_DEPOSIT';
export const CLEAR_DEPOSIT = 'CLEAR_DEPOSIT';
export const FLAG_DEPOSIT_ACTIVITY = 'FLAG_DEPOSIT_ACTIVITY';
export const GET_DEPOSIT_VOUCHER = 'GET_DEPOSIT_VOUCHER';

export const FLAG_GETTING_DEPOSIT_EDIT_HISTORY =
  'FLAG_GETTING_DEPOSIT_EDIT_HISTORY';
export const GET_DEPOSIT_EDIT_HISTORY = 'GET_DEPOSIT_EDIT_HISTORY';
export const CLEAR_DEPOSIT_EDIT_HISTORY = 'CLEAR_DEPOSIT_EDIT_HISTORY';
